<template>
	<div class="detailss-myhead">
		<div class="detailss-head">
			<div class="detailss-head-con">
				<div class="detailss-head-con-left">
					<router-link to="index">
						<img src="../../img/logo.png" alt class="detailss-logo" />
					</router-link>
					<router-link to="Novel">
						<p class="detailss-p">
							{{cateLink.catename}}
							<span class="detailss-span">></span>
						</p>
					</router-link>
					<p class="detailss-p1" @click="toworksinfo()">
						{{cateLink.title}}
						<span class="detailss-span">></span>
					</p>
					<p class="detailss-p">{{content.title}}</p>
				</div>
				<!--未登录  -->
				<div class="detailss-head-con-right" v-if="!show">
					<div class="detailss-div">
						<input
							type="text"
							class="detailss-input"
							placeholder="搜索"
							v-model="searchtitle"
							@keyup.enter="tosearch"
						/>
						<img src="../../img/ss.png" alt class="detailss-ss" @click="tosearch" />
					</div>
					<img src="../../img/use.png" alt class="detailss-use" />
					<div class="detailss-div1">
						<router-link to="/login">
							<p class="detailss-div1-p">登录</p>
						</router-link>
						<p class="detailss-div1-p">/</p>
						<router-link to="/register">
							<p class="detailss-div1-p">注册</p>
						</router-link>
					</div>
				</div>
				<!-- 已登录 -->
				<div class="detailss-head-con-right" v-if="show">
					<div class="detailss-div">
						<input
							type="text"
							class="detailss-input"
							placeholder="搜索"
							v-model="searchtitle"
							@keyup.enter="tosearch"
						/>
						<img src="../../img/ss.png" alt class="detailss-ss" @click="tosearch" />
					</div>
					<img src="../../img/use.png" alt class="detailss-use" />
					<div class="detailss-div1">
						<div @click="logout">退出</div>
					</div>
				</div>
			</div>
		</div>
		<div class="title" v-if="night=='0'">
			<div class="title1">
				<div class="title2">{{content.title}}</div>
				<div>
					<img src="../../img/time.png" alt />
					<div>更新时间:{{content.create_time_text}}</div>
					<div>字数:{{content.wordnumber}}</div>
					<div>阅读数:{{content.readnums}}</div>
				</div>
			</div>
		</div>
		<div class="title" v-if="night=='1'">
			<div class="title1" style="background-color:#1a1a1a">
				<div class="title2">{{content.title}}</div>
				<div>
					<img src="../../img/time.png" alt />
					<div>更新时间:{{content.create_time_text}}</div>
					<div>字数:{{content.wordnumber}}</div>
					<div>阅读数:123</div>
				</div>
			</div>
		</div>
		<div class="detailss-con">
			<div class="detailss-con-div">
				<div>
					<div class="detailss-mydiv" ref="contents">
						<p class="detailss-mydiv-p" v-html="content.info">
						</p>
					</div>
					<!-- <div class="detailss-mydivdiv" v-if="night=='1'">
						<p class="detailss-mydiv1-p1" v-html="content.info"></p>
					</div>-->
					<!-- 小说评论 -->
					<!-- <div class="detailss-mydiv1" v-if="night=='0'">
						<p class="detailss-mydiv1-p">
							本章评论
							<span>(共有{{commentinfo.total}}条评论)</span>
						</p>
						<el-divider></el-divider>
						<div v-for="(item, index) in comment" :key="index">
							<div class="detailss-mydiv1-div">
								<p class="detailss-mydiv1-div-p">{{item.username}}</p>
								<p class="detailss-mydiv1-div-p1">举报</p>
							</div>
							<p class="detailss-mydiv1-p1">{{item.content}}</p>
							<div class="detailss-mydiv1-div1">
								<p class="detailss-mydiv1-div1-p">{{item.username}}</p>
								<img src="../../img/pl.png" alt class="detailss-mydiv1-div1-img" />
								<p class="detailss-mydiv1-div1-p1" @click="reply(item.id,item.content)">回复</p>
							</div>
							<div v-if="item.child">
								<div class="mydetailss" v-for="(citem, cindex) in item.child.data" :key="cindex">
									<el-divider></el-divider>
									<div class="detailss-mydiv1-divdiv">
										<p class="detailss-mydiv1-div-p" style="color: #999999;">{{citem.username}}</p>
									</div>
									<p class="detailss-mydiv1-p1">{{citem.content}}</p>
									<div class="detailss-mydiv1-div1">
										<p class="detailss-mydiv1-div1-p">{{citem.username}}</p>
										<img src="../../img/pl.png" alt class="detailss-mydiv1-div1-img" />
										<p class="detailss-mydiv1-div1-p1">回复</p>
										<p class="detailss-mydiv1-div-p1">举报</p>
									</div>
								</div>
							</div>
						</div>
						<el-divider></el-divider>
						<div></div>
						<div class="detailss-mydiv1-div2" @click="djxs='0'" v-if="djxs=='1'">
							<p class="detailss-mydiv1-div2-p">查看本章更多点评</p>
							<img src="../../img/xiala.png" alt class="detailss-mydiv1-div2-img" />
						</div>
						<div class="detailss-mydiv1-div2" @click="djxs='1'" v-if="djxs=='0'">
							<p class="detailss-mydiv1-div2-p">收起本章全部点评</p>
							<img src="../../img/shangla.png" alt class="detailss-mydiv1-div2-img" />
						</div>
						<div class="detailss-mydiv1-div3">
							<button
								type="button"
								class="detailss-mydiv1-div3-btn"
								@click="centerDialogVisible = true"
							>发起评论</button>
						</div>
					</div>-->
					<publicpinglun v-if="centerDialogVisible" @fun="getMsg"></publicpinglun>
				</div>
				<div class="detailss-dw">
					<div v-if="night=='0'">
						<img src="../../img/pc_icon_cg.png" alt class="detailss-dw-img" @click="showCg()" />
						<p class="detailss-dw-p" @click="showCg()">{{showCGText}}</p>
					</div>
					<div v-if="night=='1'">
						<img src="../../img/pc_icon_cg_night.png" alt class="detailss-dw-img" @click="showCg()" />
						<p class="detailss-dw-p mylight" @click="showCg()">{{showCGText}}</p>
					</div>
					<div  class="detailss-dw-div" v-if="night=='0'">
						<img src="../../img/ml.png" alt class="detailss-dw-img" @click="toworksinfo()" />
						<p class="detailss-dw-p" @click="toworksinfo()">目录</p>
					</div>
					<div  class="detailss-dw-div" v-if="night=='1'">
						<img src="../../img/mulu.png" alt class="detailss-dw-img" @click="toworksinfo()" />
						<p class="detailss-dw-p mylight" @click="toworksinfo()">目录</p>
					</div>
					<div class="detailss-dw-div" @click="cgnight(1)" v-if="night=='0'">
						<img src="../../img/moon.png" alt class="detailss-dw-img2" />
						<p class="detailss-dw-p1">夜间</p>
					</div>
					<div class="detailss-dw-div" @click="cgnight(0)" v-if="night=='1'">
						<img src="../../img/sun.png" alt class="detailss-dw-img2" />
						<p class="detailss-dw-p1 mylight">白天</p>
					</div>
					<div class="detailss-dw-div" v-if="night=='0'">
						<img src="../../img/adf.png" alt class="detailss-dw-img1" @click="toprev" />
						<p class="detailss-dw-p1" @click="toprev">上一章</p>
					</div>
					<div class="detailss-dw-div" v-if="night=='1'">
						<img src="../../img/myl.png" alt class="detailss-dw-img1" @click="toprev" />
						<p class="detailss-dw-p1 mylight" @click="toprev">上一章</p>
					</div>
					<div class="detailss-dw-div" v-if="night=='0'" @click="tonext">
						<img src="../../img/yyyyyy.png" alt class="detailss-dw-img1" />
						<p class="detailss-dw-p1">下一章</p>
					</div>
					<div class="detailss-dw-div" v-if="night=='1'" @click="tonext">
						<img src="../../img/myr.png" alt class="detailss-dw-img1" />
						<p class="detailss-dw-p1 mylight">下一章</p>
					</div>
				</div>
				<div class="detailss-con-div-div">
					<div class="detailss-con-div-div-div">
						<img src="../../img/left.png" alt class="detailss-leftimg" @click="toprev" />
						<p class="detailss-leftp" @click="toprev">上一章</p>
					</div>
					<div class="detailss-con-div-div-div">
						<p class="detailss-conp">{{content.ji_no}}/{{count}}话</p>
					</div>
					<div class="detailss-con-div-div-div1">
						<p class="detailss-leftp" @click="tonext">下一章</p>
						<img src="../../img/right.png" alt class="detailss-rightimg" @click="tonext" />
					</div>
				</div>
				<!-- <div class="detailss-foot">
					<button type="button" class="detailss-btn" @click="reward()">打赏</button>
				</div>-->
			</div>
		</div>
		<publicmyhfmtk
			v-if="dialogTableVisible"
			@func="getMsgFormSon"
			:id="replyid"
			:replycomment="replycomment"
		></publicmyhfmtk>
		<modelReward :Reward="Reward" :bookReward="bookReward"></modelReward>
		<div class="tips" v-show="showTips">
			<i class="tips_close" @click="closeTip">×</i>
			<p class="tips_text">订阅和评论是作者继续更新的动力, 如果你喜欢这部作品</p>
			<router-link to="/register">
				<button class="tips_btn">去注册</button>
			</router-link>
		</div>
	</div>
</template>

<script>
	import publicpaging from "../publicpaging.vue";
	import publicmyhfmtk from "../publicmyhfmtk.vue";
	import publicpinglun from "../publicpinglun.vue";
	import modelReward from "../modelReward.vue";
	export default {
		name: "App",
		components: {
			publicpaging,
			publicmyhfmtk,
			publicpinglun,
			modelReward
		},
		data() {
			return {
				dialogTableVisible: false,
				centerDialogVisible: false,
				night: "0",
				djxs: "1",
				notedata: "",
				tips: "",
				commentdata: "",
				tomycomment: "",
				Reward: false,
				cateLink: "",
				content: "",
				count: "",
				prev: "",
				next: "",
				bookReward: "",
				comment: "",
				replyid: "",
				replycomment: "",
				commentinfo: "",
				searchtitle: "",
				show: false,
				index: this.$route.query.index,
				episodes: "",
				showTips:false,
				showCgs:false,
				showCGText:"显示CG"
			};
		},
		methods: {
			getMsgFormSon(data) {
				this.dialogTableVisible = data;
			},
			getMsg(data) {
				this.centerDialogVisible = data;
			},
			tocomment() {
				if (this.commentdata.length < 5) {
					this.tomycomment = "1";
					setTimeout(res => {
						this.tomycomment = "0";
					}, 2000);
				}
			},
			reward() {
				var bookReward = {
					token: "",
					bid: this.content.bid,
					ji_no: this.content.ji_no,
					reader: "",
					publish: this.cateLink.publish,
					type: "book"
				};
				this.bookReward = bookReward;
				this.Reward = !this.Reward;
			},
			reply(id, content) {
				this.dialogTableVisible = true;
				this.replyid = id;
				this.replycomment = content;
				console.log(this.dialogTableVisible, this.replyid, this.replycomment);
			},
			toworksinfo() {
				this.$router.push({
					name: "works",
					query: { id: this.$route.query.id }
				});
			},
			tosearch() {
				if (this.searchtitle) {
					const serach = this.$router.resolve({
						path: "/searchzixun",
						query: { searchtitle: this.searchtitle }
					});
					window.open(serach.href, "_blank");
				}
			},
			closeTip()
			{
				this.showTips = false;
				let storage = window.localStorage;
			},
			logout() {
				this.$http
					.post(`user/logout`, {
						token: this.$cookies.get("token")
					})
					.then(res => {
						if (res.body.code == 1) {
							this.$cookies.remove("token");
							this.show = false;
						}
					});
			},
			tonext() {
				console.log("next");
				if (this.index < this.episodes.length - 1) {
					var id = this.episodes[Number(this.index) + Number(1)].id;
					this.getfictionContentList(id);
					this.index = Number(this.index * 1 + 1);
					let storage = window.localStorage;
					let isView = storage.getItem("isView");
					if(this.index == 10 && !isView && !this.$cookies.isKey("token"))
					{
						this.showTips = true;
						storage.setItem("isView", "true");
					}
					if(this.showCgs)
					{
						this.showCGText = "显示CG";
							var imgs = document.querySelectorAll(".detailss-mydiv img");
						for(var i = 0 ; i < imgs.length; i ++ )
						{
							imgs[i].style.display = "none";
						}
					}
					else
					{
						this.showCGText = "隐藏CG";
						var imgs = document.querySelectorAll(".detailss-mydiv img");
						for(var i = 0 ; i < imgs.length; i ++ )
						{
							imgs[i].style.display = "block";
						}
					}
				} else {
					this.$message("已经是最后一章了");
				}
			},
			toprev() {
				if (this.index > 0) {
					var id = this.episodes[Number(this.index) - Number(1)].id;
					this.getfictionContentList(id);
					this.index = Number(this.index * 1 - 1);
					let storage = window.localStorage;
					let isView = storage.getItem("isView");
					if(this.index == 10 && !isView && !this.$cookies.isKey("token"))
					{
						this.showTips = true;
						storage.setItem("isView", "true");
					}
					if(this.showCgs)
					{
						this.showCGText = "显示CG";
						var imgs = document.querySelectorAll(".detailss-mydiv img");
						for(var i = 0 ; i < imgs.length; i ++ )
						{
							imgs[i].style.display = "none";
						}
					}
					else
					{
						this.showCGText = "隐藏CG";
						var imgs = document.querySelectorAll(".detailss-mydiv img");
						for(var i = 0 ; i < imgs.length; i ++ )
						{
							imgs[i].style.display = "block";
						}
					}
				} else {
					this.$message("已经是第一章了");
				}
			},
			getdir() {
				this.$http
					.get(`book/dir/${this.$route.query.id}`)
					.then(response => {
						this.episodes = response.data.data.episodes;
						console.log("episodes", this.episodes);
					})
					.catch(response => {
						console.log(response);
					});
			},
			getfictionContentList(id = this.$route.query.id) {
				this.$http
					.get(`book/data/${id}`)
					.then(response => {
						console.log("加载数据");
						setTimeout(function(){
							var imgs = document.querySelectorAll(".detailss-mydiv img");
							for(var i = 0 ; i < imgs.length; i ++ )
							{
								if(!this.showCgs)
								{
									imgs[i].style.display = "none";
								}
								else
								{
									imgs[i].style.display = "block";
								}
								if(imgs[i].src.indexOf("obi")==-1)
								{
									imgs[i].src  = imgs[i].src.replace("uploads","obi/uploads");
								}
							}
						},1000)
						this.content = response.data.data.content;
						document.documentElement.scrollTop = document.body.scrollTop = 0;
					})
					.catch(response => {
						console.log(response);
					});
			},
			backTop() {
				const that = this;
				let timer = setInterval(() => {
					let ispeed = Math.floor(-that.scrollTop / 5);
					document.documentElement.scrollTop = document.body.scrollTop =
						that.scrollTop + ispeed;
					if (that.scrollTop === 0) {
						clearInterval(timer);
					}
				}, 16);
			},
			cgnight(num) {
				this.night = num;
				if (num == 1) {
					this.$refs.contents.style.backgroundColor = "#1a1a1a";
					this.$refs.contents.style.color = "#999";
				} else {
					this.$refs.contents.style.backgroundColor = "white";
					this.$refs.contents.style.color = "black";
				}
			},
			showCg()
			{
				this.showCgs = !this.showCgs;
				if(!this.showCgs)
				{
					this.showCGText = "显示CG";
						var imgs = document.querySelectorAll(".detailss-mydiv img");
					for(var i = 0 ; i < imgs.length; i ++ )
					{
						imgs[i].style.display = "none";
					}
				}
				else
				{
					this.showCGText = "隐藏CG";
					var imgs = document.querySelectorAll(".detailss-mydiv img");
					for(var i = 0 ; i < imgs.length; i ++ )
					{
						imgs[i].style.display = "block";
					}
				}
			}
		},
		created() {
			this.getdir();
			this.$http.get("book/data/" + this.$route.query.ji_no).then(res => {
				console.log("加载数据");
				setTimeout(function(){
					var imgs = document.querySelectorAll(".detailss-mydiv img");
					for(var i = 0 ; i < imgs.length; i ++ )
					{
						imgs[i].style.display = "none";
						if(imgs[i].src.indexOf("obi")==-1)
						{
							imgs[i].src  = imgs[i].src.replace("uploads","obi/uploads");
						}
					}
				},1000)
				this.cateLink = res.body.data.cateLink;
				this.content = res.body.data.content;
				this.count = res.body.data.count;
				this.prev = res.body.data.prev;
				this.next = res.body.data.next;
			});
			this.$http.get(`comment/show/book/${this.$route.query.id}`).then(res => {
				this.comment = res.body.msg.data;
				this.commentinfo = res.body.msg;
			});
			if (this.$cookies.isKey("token")) {
				this.show = true;
				console.log("show", this.show);
			} else {
				this.show = false;
			}
		},
		mounted() {
			window.addEventListener("scroll", this.scrollToTop);
		},
		destroyed() {
			window.removeEventListener("scroll", this.scrollToTop);
		}
	};
</script>

<style>
	.title {
		width: 100%;
		text-align: center;
		background-color: #212121;
		color: #212121;
		display: flex;
		justify-content: center;
		height: 100px;
	}
	.title1 {
		width: 960px;
		background-color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.title2 {
		font-size: 18px !important;
		color: #212121;
	}
	.title1 img {
		height: 16px;
		width: 16px;
		margin-top: 10px;
		margin-right: 6px;
	}
	.title1 div {
		display: flex;
		flex-direction: row;
		align-content: center;
		justify-content: center;
		font-size: 14px;
		margin-right: 12px;
		margin-top: 8px;
		color: #808080;
	}
	.myhfmtk-div-con-p {
		font-size: 14px;
	}

	.myhfmtk-div-con {
		width: 140px;
		height: 70px;
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(204, 204, 204, 1);
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 100px;
		left: 210px;
	}

	.myhfmtk-div-body-div-btn {
		width: 70px;
		height: 36px;
		background: rgba(204, 204, 204, 1);
		border-radius: 4px;
		border: 0;
		font-size: 14px;
		color: #ffffff;
		margin-right: 30px;
	}

	.myhfmtk-div-body-div-btn1 {
		width: 70px;
		height: 36px;
		background-color: #28a3b1;
		border-radius: 4px;
		border: 0;
		font-size: 14px;
		color: #fff;
		margin-right: 30px;
	}

	.myhfmtk-div-body-div {
		display: flex;
		justify-content: flex-end;
		margin-top: 30px;
	}

	.myhfmtk-div-body-txt {
		width: 520px;
		height: 270px;
		resize: none;
		border: 0;
		border-bottom: 1px solid #e6e6e6 !important;
		outline: none;
	}

	.myhfmtk-div-top-p1 {
		font-size: 16px;
		color: #ffffff;
	}

	.myhfmtk-div-top-p2 {
		font-size: 14px;
		color: #ffffff;
		margin-top: 16px;
		padding-left: 7px;
		box-sizing: border-box;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.myhfmtk-div-body {
		width: 560px;
		height: 387px;
		background: rgba(255, 255, 255, 1);
		border-radius: 0px 0px 12px 12px;
		padding: 20px;
		box-sizing: border-box;
	}

	.myhfmtk-div-top {
		width: 560px;
		height: 133px;
		background: rgba(40, 163, 177, 1);
		border-radius: 12px 12px 0px 0px;
		padding: 16px 17px;
		box-sizing: border-box;
	}

	.myhfmtk {
		width: 100%;
		height: 100%;
		position: fixed;
		display: flex;
		justify-content: center;
		top: 0;
		left: 0;
		align-items: center;
	}

	.myhfmtk-div1 {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 1);
		opacity: 0.3;
		position: absolute;
	}

	.myhfmtk-div {
		width: 560px;
		height: 500px;
		z-index: 10000;
		position: relative;
	}

	.el-dialog__header {
		padding: 0;
	}

	.detailss-divs-btn {
		width: 80px;
		height: 32px;
		border: 0;
		border-radius: 4px;
		background-color: #28a3b1;
		color: #fff;
		font-size: 12px;
	}

	.detailss-divs-p {
		font-size: 12px;
		color: #cc2929;
	}

	.detailss-divs {
		display: flex;
		justify-content: flex-end;
		margin: 10px 0 0;
	}

	.el-dialog__body {
		padding: 30px 20px;
		box-sizing: border-box;
	}

	.detailss-textarea {
		resize: none;
		width: 680px;
		min-height: 260px;
		border-radius: 8px;
		border: 1px solid #cccccc;
		padding: 10px;
		box-sizing: border-box;
		font-size: 12px;
	}

	.el-dialog {
		margin-top: 20vh;
		width: 850px !important;
		border-radius: 8px;
		height: 394px;
	}

	.el-dialog__headerbtn {
		display: none;
	}

	.el-pagination {
		display: flex;
		justify-content: center;
	}

	.el-pager li.active {
		color: #28a3b1;
	}

	.el-pager li:hover {
		color: #28a3b1;
	}

	.el-pager {
		background-color: #fff;
	}

	.detailss-myimg {
		width: 14px;
		height: 12px;
		margin: 0 10px;
	}

	.mytop {
		margin-top: 30px;
	}

	.mydetailss {
		padding-left: 30px;
		box-sizing: border-box;
	}

	.mylight {
		color: #ffffff !important;
	}

	.detailss-head {
		width: 100%;
		height: 70px;
		background-color: #1a1a1a;
		box-sizing: border-box;
		padding: 0 80px;
	}

	.detailss-con {
		width: 100%;
		padding: 0px 40px 40px;
		box-sizing: border-box;
		background-color: #212121;
		display: flex;
		justify-content: center;
	}

	.detailss-head-con {
		display: flex;
		justify-content: space-between;
	}

	.detailss-head-con-left {
		height: 70px;
		display: flex;
		align-items: center;
	}

	.detailss-logo {
		width: 140px;
		height: 46px;
		margin-right: 20px;
	}

	.detailss-p {
		font-size: 22px;
		color: #999999;
	}

	.detailss-p1 {
		font-size: 22px;
		color: #ffffff;
		cursor: pointer;
	}

	.detailss-span {
		font-size: 16px;
		color: #999999;
	}

	.detailss-head-con-right {
		display: flex;
		align-items: center;
		height: 70px;
	}

	.detailss-div {
		position: relative;
	}

	.detailss-input {
		width: 240px;
		height: 36px;
		padding-left: 16px;
		border-radius: 18px;
		background-color: #b3b3b3;
		font-size: 16px;
		border: 0;
	}

	.detailss-ss {
		width: 20px;
		height: 20px;
		position: absolute;
		top: 8px;
		right: 16px;
	}

	.detailss-use {
		width: 34px;
		height: 34px;
		margin: 0 10px;
	}

	.detailss-div1 {
		display: flex;
	}
	.detailss-div1 div {
		color: #999999;
		cursor: pointer;
	}
	.detailss-div1-p {
		font-size: 22px;
		color: #999999;
	}

	.detailss-con-div {
		width: 960px;
		position: relative;
	}

	.detailss-con-div-div {
		width: 420px;
		height: 50px;
		border-radius: 25px;
		background-color: #ff2853;
		margin: 40px auto;
		box-sizing: border-box;
		padding: 0 20px;
		display: flex;
		justify-content: space-around;
	}

	.detailss-con-div-div-div {
		display: flex;
		margin-right: 20px;
		align-items: center;
	}

	.detailss-con-div-div-div1 {
		display: flex;
		align-items: center;
	}

	.detailss-leftimg {
		width: 24px;
		height: 24px;
		margin-right: 10px;
		cursor: pointer;
	}
	.detailss-rightimg {
		width: 24px;
		height: 24px;
		margin-left: 10px;
		cursor: pointer;
	}

	.detailss-leftp {
		font-size: 22px;
		color: #fff;
		cursor: pointer;
	}

	.detailss-conp {
		font-size: 14px;
		color: #fff;
	}

	.detailss-btn {
		width: 70px;
		height: 70px;
		background: rgba(247, 242, 232, 1);
		border-radius: 50%;
		border: 0;
		font-size: 16px;
		font-weight: bold;
		margin: 0 auto;
	}

	.detailss-foot {
		display: flex;
		justify-content: center;
	}

	.detailss-dw {
		width: 70px;
		height: 510px;
		border-radius: 6px;
		background-color: #292929;
		box-sizing: border-box;
		padding: 18px 10px;
		position: absolute;
		left: 50%;
		margin-left: 485px;
		top: 50%;
		margin-top: -255px;
		text-align: center;
	}

	.detailss-dw-img {
		width: 34px;
		height: 34px;
		margin: 0 auto;
		cursor: pointer;
	}

	.detailss-dw-img1 {
		width: 18px;
		height: 34px;
		margin: 0 auto;
		cursor: pointer;
	}

	.detailss-dw-img2 {
		width: 32px;
		height: 34px;
		margin: 0 auto;
		cursor: pointer;
	}

	.detailss-dw-p {
		font-size: 16px;
		color: #666666;
		text-align: center;
		margin-top: 10px;
		cursor: pointer;
	}

	.detailss-dw-p1 {
		font-size: 14px;
		color: #666666;
		text-align: center;
		margin-top: 10px;
		cursor: pointer;
	}

	.detailss-dw-div {
		margin-top: 40px;
		
	}

	.detailss-mydiv {
		width: 960px;
		min-height: 100vh;
		padding: 0px 30px 50px 30px;
		background-color: #fff;
		box-sizing: border-box;
	}

	.detailss-mydiv img
	{
		display:block;
		width: 100% !important;
    	/* width: auto !important; */
		height: auto!important;
		/* max-height: 1000px; */
		margin: 0 auto;
	}

	.detailss-mydivdiv {
		width: 960px;
		min-height: 100vh;
		padding: 30px;
		background-color: #1a1a1a;
		box-sizing: border-box;
	}

	.detailss-myhead {
		min-height: 100vh;
		background-color: #212121;
	}

	.detailss-mydiv-p {
		font-size: 18px;
		text-indent: 2em;
	}

	.detailss-mydiv1 {
		width: 960px;
		padding: 30px 20px;
		margin-top: 10px;
		background-color: #fff;
		box-sizing: border-box;
	}

	.detailss-mydiv12 {
		width: 960px;
		padding: 30px 20px;
		margin-top: 10px;
		background-color: #1a1a1a;
		box-sizing: border-box;
	}

	.detailss-mydiv1-p {
		font-size: 16px;
		margin-right: 2px;
	}

	.detailss-mydiv1-p span {
		font-size: 12px;
		color: #808080;
	}

	.detailss-mydiv1-div {
		display: flex;
		justify-content: space-between;
	}

	.detailss-mydiv1-divdiv {
		display: flex;
		align-items: center;
	}

	.detailss-mydiv1-div-p {
		font-size: 12px;
		font-weight: bold;
	}

	.detailss-mydiv1-div-p1 {
		font-size: 12px;
		color: #808080;
	}

	.detailss-mydiv1-p1 {
		font-size: 16px;
		margin-top: 20px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;
		font-size: 18px;
		color: #999999;
		min-height: 300vh;
		overflow: hidden;
	}

	.detailss-mydiv1-div1 {
		display: flex;
		margin-top: 40px;
		align-items: center;
	}

	.detailss-mydiv1-div1-p {
		font-size: 12px;
		color: #808080;
		margin-right: 20px;
	}

	.detailss-mydiv1-div1-img {
		width: 16px;
		height: 14px;
		margin-right: 10px;
	}

	.detailss-mydiv1-div1-p1 {
		font-size: 12px;
		color: #28a3b1;
		margin-right: 40px;
		cursor: pointer;
	}

	.detailss-mydiv1-div2 {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
	}

	.detailss-mydiv1-div2-p {
		font-size: 14px;
		margin-right: 5px;
	}

	.detailss-mydiv1-div2-img {
		width: 12px;
		height: 6px;
	}

	.detailss-mydiv1-div3 {
		display: flex;
		justify-content: center;
		margin-top: 40px;
	}

	.detailss-mydiv1-div3-btn {
		width: 120px;
		height: 44px;
		border: 0;
		background-color: #28a3b1;
		border-radius: 8px;
		color: #fff;
		font-size: 16px;
		font-weight: bold;
	}
	.tips
	{
		background: #fff;
		position: fixed;
		left: 50%;
		width: 330px;
		margin-left: -165px;
		height: 140px;
		top:50%;
		padding: 1.5rem;
		box-shadow: 0 0 23px rgba(0, 0, 0, 0.3);
		border-radius: 10px;
		text-align: center;
		
	}
	.tips_close
	{
		position: absolute;
		right: 0.5em;
		top: 0.5em;
		font-style: normal;
		cursor: pointer;
	}
	p.tips_text
	{
		text-align:left;
		margin-bottom: 1em;
	}
	button.tips_btn
	{
		background: #f9548d;
		padding: 0.3rem 0.7rem;
		font-size: 1rem;
		border-radius: 3px;
		border: none;
		color: #fff;
		margin: 1em 0.5em;
	}
	.showCg
	{
		position: fixed;
		top: 1.2rem;
		right: 0.2rem;
		background: #ff8b8b;
		color: #fff;
		font-size: 0.3rem;
		padding: 0.15rem 0.3rem;
		font-style: normal;
		font-weight: bold;
		border-radius: 2em;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/Novel/detailss.vue